import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/stickyHeader';
import olcBanner from '../assets/olc_banner_no_logo.png';
import iconAsk from '../assets/ask-the-expert.png';
import iconBook from '../assets/icon.png';
import iconEnter from '../assets/enter.png';
import questionApi from '../services/questionActions';
import { message } from 'antd';
import badgeIcon from '../images/badgeIcon.png';

import module0 from '../images/latest/module-0.png';
import lockedModule from '../images/lockedModule.png';
import CertificatePopup from '../components/CertificatePopup';
import { useSelector } from 'react-redux';

import TakeSurveyModal from '../components/TakeSurveyModal';
const moment = require('moment');

const Modules = () => {
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);
  const [zeroModules, setZeroModules] = useState([]);
  const [coreModules, setCoreModules] = useState([]);
  const [completeCore, setCompleteCore] = useState(false);
  const [bonusModules, setBonusModules] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [completedModule, setCompletedModule] = useState(null);
  const [isModalSurveyPreOpen, setIsModalSurveyPreOpen] = useState(false);
  const [isModalSurveyOpen, setIsModalSurveyOpen] = useState(false);
  const [postSurveyNeedToComplete, setPostSurveyNeedToComplete] =
    useState(false);

  const [showm5, setShowm5] = useState(false);
  const [showm8, setShowm8] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showMoreHander = (idx, type) => {
    if (idx == 5) {
      if (type === 'open') {
        setShowm5(true);
      } else {
        setShowm5(false);
      }
    } else if (idx == 8) {
      if (type === 'open') {
        setShowm8(true);
      } else {
        setShowm8(false);
      }
    }
  };

  const renderDoctorInfo = (idx) => {
    let doctor = speakers.find((e) => e.modules.includes(idx));

    if (Number(idx) === 5) {
      const module5Doctors = speakers.filter((e) => e.modules.includes('5'));
      return (
        <>
          {showm5 ? (
            <div>
              {module5Doctors.map((doctor, id) => {
                return (
                  <div key={id} className="mt-2">
                    <div className="instructor">
                      {doctor.title} {doctor.name}
                    </div>
                    <div className="position">{doctor.speciality}</div>
                    <div className="position">{doctor.sector}</div>
                  </div>
                );
              })}
              <div
                className="see-more-btn"
                onClick={() => showMoreHander(5, 'close')}
              >
                Read Less
              </div>
            </div>
          ) : !showm5 ? (
            <>
              <div className="instructor">
                {module5Doctors[0]?.title} {module5Doctors[0]?.name}
              </div>
              <div className="position">{module5Doctors[0]?.speciality}</div>
              <div className="position">{module5Doctors[0]?.sector}</div>

              <div
                className="see-more-btn"
                onClick={() => showMoreHander(5, 'open')}
              >
                Read More
              </div>
            </>
          ) : null}
        </>
      );
    } else {
      return (
        <>
          <div className="instructor">
            {doctor.title} {doctor.name}
          </div>
          <div className="position">{doctor.speciality}</div>
          <div className="position">{doctor.sector}</div>{' '}
        </>
      );
    }
  };

  const renderDoctorInfoBonus = (idx) => {
    let doctor = {};
    const module8Doctors = speakers.filter((e) => e.modules.includes('8'));
    if (idx) {
      doctor = speakers.find((e) => e.modules.includes(idx));
    }

    if (Number(idx) === 8) {
      return (
        <>
          {showm8 ? (
            <div>
              {module8Doctors.map((doctor, id) => {
                return (
                  <div key={id} className="mt-2">
                    <div className="instructor">
                      {doctor.title} {doctor.name}
                    </div>
                    <div className="position">{doctor.speciality}</div>
                    <div className="position">{doctor.sector}</div>
                  </div>
                );
              })}
              <div
                className="see-more-btn"
                onClick={() => showMoreHander(idx, 'close')}
              >
                Read Less
              </div>
            </div>
          ) : !showm8 ? (
            <>
              <div className="instructor">
                {module8Doctors[0]?.title} {module8Doctors[0]?.name}
              </div>
              <div className="position">{module8Doctors[0]?.speciality}</div>
              <div className="position">{module8Doctors[0]?.sector}</div>

              <div
                className="see-more-btn"
                onClick={() => showMoreHander(8, 'open')}
              >
                Read More
              </div>
            </>
          ) : null}
        </>
      );
    } else {
      return (
        <>
          <div className="instructor">
            {doctor.title} {doctor.name}
          </div>
          <div className="position">{doctor.speciality}</div>
          <div className="position">{doctor.sector}</div>{' '}
        </>
      );
    }
  };

  useEffect(() => {
    const getModules = async () => {
      try {
        const res = await questionApi.getModulesData();

        // console.log('res,modules ---', res);
        if (res) {
          const zeromod = res?.data.modules.filter((item) => item.id === '10');
          const coreModules = res?.data.coreModules;
          const bonmod = res?.data.bonusModules;

          setZeroModules(zeromod);
          setCoreModules(coreModules);
          setBonusModules(bonmod);
          setSpeakers(res.data.speakers);
        }
      } catch (error) {
        if (error.response?.data.error) {
          message.error(error.response?.data.error);
        }
      }
    };
    getModules();
  }, []);

  useEffect(() => {
    const getCompletedModules = async () => {
      try {
        const res = await questionApi.getModulesWithCompletion();

        const postSurveyData = await fetch(
          `/api/survey/check?userId=${user.id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        const surveyData = await postSurveyData.json();

        if (res) {
          setCompleteCore(res.data.bonusUnlocked);
          // console.log('res.data', res.data);
          const allCompleted = res.data.allCompleted;
          const v2coreUserModules = res.data.v2coreUserModules;

          const preSurveyCompleted = surveyData?.data?.find(
            (each) => each.type === 'pre'
          );
          const postSurveyCompleted = surveyData?.data?.find(
            (each) => each.type === 'post'
          );

          // survey data
          if (surveyData.data) {
            if (!preSurveyCompleted) {
              setIsModalSurveyPreOpen(true);
            }
          }
          // console.log('allCompleted', allCompleted);
          if (allCompleted && preSurveyCompleted && !postSurveyCompleted) {
            setPostSurveyNeedToComplete(true);
          }

          if (allCompleted) {
            const getComDate = v2coreUserModules.sort((a, b) => {
              const date1 = moment(a.assessment_completion);
              const date2 = moment(b.assessment_completion);

              if (date1.isBefore(date2)) {
                return 1;
              } else if (date1.isAfter(date2)) {
                return -1;
              } else {
                return 0;
              }
            });

            if (getComDate[0]) {
              const convertedDate = moment(
                getComDate[0].assessment_completion
              ).format('DD/MM/YYYY');
              setCompletedModule(convertedDate);
            }
          }
        }
      } catch (error) {
        if (error.response?.data.error) {
          message.error(error.response?.data.error);
        }
      }
    };
    if (user) {
      getCompletedModules();
    }
  }, [user]);

  return (
    <div className="main-container">
      <Header navigate={navigate} />
      <TakeSurveyModal
        isModalSurveyOpen={isModalSurveyOpen}
        navigate={navigate}
        description={
          <div>
            Kindly complete the Post-training Survey to
            <div>download your Advocate certificate.</div>
          </div>
        }
        action={() => navigate('/survey/post/one')}
      />
      <TakeSurveyModal
        isModalSurveyOpen={isModalSurveyPreOpen}
        navigate={navigate}
        description={
          <div>
            Kindly complete the Pre-training Survey to
            <div>proceed to the learning modules.</div>
          </div>
        }
        action={() => navigate('/survey/pre/one')}
      />
      <CertificatePopup
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        completedModule={completedModule}
      />
      <div className="text-center">
        <img className="olc-banner" src={olcBanner} alt="banner" />

        {completedModule ? (
          <div className="text-white mt-4 ">
            <img src={badgeIcon} style={{ height: '50px' }} alt="badgeIcon" />
            <div style={{ fontWeight: '700', fontSize: '20px' }}>
              Great Job!
            </div>
            <div className="py-2">
              <div>You have already completed all your modules, find out</div>
              <div>what you can do with your certification!</div>
            </div>

            <div>
              <button
                className="custom-button mt-3 fw-bold"
                style={{
                  background: '#F0D474',
                  padding: '7px 5rem',
                  color: '#3B638C',
                }}
                onClick={() => {
                  if (postSurveyNeedToComplete) {
                    setIsModalSurveyOpen(true);
                  } else {
                    setIsModalOpen(true);
                  }
                }}
              >
                Completion Certificate
              </button>
            </div>

            <div className="shadow-sm" style={{ height: '4rem' }}></div>
          </div>
        ) : null}
      </div>
      <div className="modules-header">
        <h1>Core Modules</h1>
      </div>
      <div className="modules-container">
        {zeroModules.length
          ? zeroModules.map((module, idx) => {
              return (
                <div
                  className="card"
                  style={{
                    borderRadius: '20px',
                    border: 'none',
                    backgroundImage: `url(${module0})`,
                  }}
                  key={idx}
                >
                  <div className="card-overlay">
                    <div className="card-top" style={{ cursor: 'pointer' }}>
                      <span
                        className="ask-expert"
                        onClick={() =>
                          navigate(`/ask-the-expert?module=${idx}`)
                        }
                      >
                        Ask the experts
                        <img
                          className="icon-ask ml2 mb-1 ms-2"
                          alt="icon"
                          src={iconAsk}
                        />
                      </span>
                    </div>
                    <div className="card-middle px-3 pb-2 pt-0">
                      <img
                        className="book-icon"
                        alt="Book Icon"
                        src={iconBook}
                      />
                      <div className="card-info">
                        <div className="module">
                          {' '}
                          {module.title} (not inclusive of CPD points)
                        </div>
                        <div className="title" style={{ minHeight: '80px' }}>
                          {module.description}
                        </div>
                        {renderDoctorInfo(idx)}
                      </div>
                    </div>
                    <div className="card-bottom">
                      <button
                        className="enter-btn"
                        onClick={() => {
                          navigate(`/video?module=${idx}`, {
                            state: module,
                          });
                          window.location.href = `/video?module=${idx}`;
                        }}
                      >
                        Enter
                        <img
                          src={iconEnter}
                          className="enter-icon mb-1 ms-2"
                          alt="icon"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
      <div className="modules-container-reverse">
        {coreModules.length
          ? coreModules.map((module, index) => {
              const idx = index + 1;
              return (
                <div
                  className="card"
                  style={{
                    borderRadius: '20px',
                    border: 'none',
                  }}
                  key={idx}
                >
                  <div className="card-overlay">
                    <div className="card-top" style={{ cursor: 'pointer' }}>
                      <span
                        className="ask-expert"
                        onClick={() =>
                          navigate(`/ask-the-expert?module=${idx}`)
                        }
                      >
                        Ask the experts
                        <img
                          className="icon-ask ml2 mb-1 ms-2"
                          alt="icon"
                          src={iconAsk}
                        />
                      </span>
                    </div>
                    <div className="card-middle px-3 pb-2 pt-0">
                      <img
                        className="book-icon"
                        alt="Book Icon"
                        src={iconBook}
                      />
                      <div className="card-info">
                        <div className="module"> {module.title}</div>
                        <div className="title" style={{ minHeight: '80px' }}>
                          {module.description}
                        </div>
                        {renderDoctorInfo(idx)}
                      </div>
                    </div>
                    <div className="card-bottom">
                      <button
                        className="enter-btn"
                        onClick={() => {
                          navigate(`/video?module=${idx}`, {
                            state: module,
                          });
                          window.location.href = `/video?module=${idx}`;
                        }}
                      >
                        Enter
                        <img
                          src={iconEnter}
                          className="enter-icon mb-1 ms-2"
                          alt="icon"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
      {/* /// New one */}
      <div className="modules-header-no-underline">
        <h1 className="text-underline">Bonus Modules</h1>
        <p>
          Bonus Modules are accessible upon completion of the Core Modules (M0
          is optional).
        </p>
      </div>
      <div className="modules-container">
        {bonusModules.length
          ? bonusModules
              .sort((a, b) => a.id - b.id)
              .map((module, index) => {
                const idx = index + coreModules.length + zeroModules.length;
                return (
                  <div
                    className="card"
                    style={{
                      borderRadius: '20px',
                      backgroundColor: !completeCore ? '#C0B169' : '',
                      border: 'none',
                    }}
                    key={idx}
                  >
                    <div className="card-overlay">
                      <div className="card-top" style={{ cursor: 'pointer' }}>
                        <span
                          className="ask-expert"
                          onClick={() => {
                            if (completeCore) {
                              navigate(`/ask-the-expert?module=${idx}`);
                            }
                          }}
                        >
                          Ask the experts
                          <img
                            className="icon-ask ml2 mb-1 ms-2"
                            alt="icon"
                            src={iconAsk}
                          />
                        </span>
                      </div>
                      <div className="card-middle px-3 pb-2 pt-0">
                        <img
                          className="book-icon"
                          alt="Book Icon"
                          src={iconBook}
                        />
                        <div className="card-info">
                          <div className="module">Module {idx}</div>
                          {completeCore ? (
                            <>
                              <div
                                className="title"
                                style={{ minHeight: '80px' }}
                              >
                                {module.description}
                              </div>
                              {renderDoctorInfoBonus(idx)}
                            </>
                          ) : (
                            <img
                              src={lockedModule}
                              className="d-flex"
                              style={{
                                height: 'auto',
                                width: '5rem',
                                alignSelf: 'center',
                                margin: '10px 0',
                              }}
                              alt="locked-module"
                            ></img>
                          )}
                        </div>
                      </div>
                      {completeCore ? (
                        <div className="card-bottom">
                          <button
                            className="enter-btn"
                            onClick={() => {
                              navigate(`/video?module=${idx}`, {
                                state: module,
                              });
                              window.location.href = `/video?module=${idx}`;
                            }}
                          >
                            Enter
                            <img
                              src={iconEnter}
                              className="enter-icon mb-1 ms-2"
                              alt="icon"
                            />
                          </button>
                        </div>
                      ) : (
                        <div className="card-bottom"></div>
                      )}
                    </div>
                  </div>
                );
              })
          : null}
      </div>{' '}
      */}
    </div>
  );
};

export default Modules;
